import axios from 'axios';

export function getContact(vesselId, contactId) {
    return axios.get(`/api/?entity=contacts&action=getContact&vessel_id=${vesselId}&contact_id=${contactId}`);
}
